import { toastController } from '@ionic/vue'

export async function wiseToast(settings) {
	const toast = await toastController
	.create({
		position: 'top',
        duration: 3000,
        color: document.body.classList.contains('dark') ? 'light' : 'dark',
        buttons: [ 'OK' ],
		...settings,
	})

	await toast.present()

	return toast
}